import { useSelector } from 'react-redux'

import { faPlus } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../antd/Buttons/IconButton'
import SchoolModal from '../../../../Providers/Forms/SchoolModal'
import SchoolsSelector from './SchoolsSelector'
import { School } from '../../../../utils/entities/school'

const ExtendedSchoolsSelector = ({
  className = '', disabled, dropdownDisabled, schools = null, multiple = 'default', reverse = false, style = {}, values, onChange, onSchoolSubmit
}) => {
  const t = useSelector(selectTranslate)

  const renderDropdown = onClick => menu => (
    <div>
      {menu}
      <div className='flex-col m-4' onMouseDown={e => e.preventDefault()}>
        <IconButton
          text={t('form.request.new_school')}
          icon={faPlus}
          onClick={() => onClick(handler => ({ ...handler, data: new School(), callback: onSchoolSubmit }))}
        />
      </div>
    </div>
  )

  return (
    <SchoolModal>
      <SchoolsSelector
        className={className}
        disabled={disabled}
        multiple={multiple}
        reverse={reverse}
        schools={schools}
        style={style}
        values={values}
        dropdownRender={!dropdownDisabled && renderDropdown}
        onChange={onChange}
      />
    </SchoolModal>
  )
}

export default ExtendedSchoolsSelector
